
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/consorcio/contato",
      function () {
        return require("private-next-pages/consorcio/contato.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/consorcio/contato"])
      });
    }
  